import { ROLE_TYPES } from 'rbac/roles'
import { isInsuranceLogin } from 'tools/auth'

export interface IRoleOption {
  value: string
  label: string
}

/**
 * Options for the User Management role dropdowns. CLAIMS_ONLY is offered to insurance tenants only,
 * mirroring the server-side restriction in RoleEligibilityService — offering it elsewhere just
 * produces a 400 on save. Evaluated per call so it tracks the current login.
 */
export const getRoleOptions = (): IRoleOption[] => {
  const options: IRoleOption[] = [
    { value: ROLE_TYPES.ADMIN, label: 'Admin' },
    { value: ROLE_TYPES.VIEW_ONLY, label: 'View Only' },
  ]

  if (isInsuranceLogin()) {
    options.push({ value: ROLE_TYPES.CLAIMS_ONLY, label: 'Claims Only' })
  }

  return options
}

export default getRoleOptions
